import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import QuestionService from '@/core/services/question.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditQuestionsComponent extends Vue {
  questionService: any = new QuestionService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  surveyList: any = [];
  sectionList: any = [];
  skillList: any = [];
  question: string = "";
  survey: string = "";
  skill: string = "";
  optionOne: any = "";
  optionTwo: any = "";
  optionThree: any = "";
  optionFour: any = "";
  options: any = [];
  title: string = "";
  skill: any = "default";
  section: any = "default";
  survey: any = "default";
  optionsList: any = [];
  questionNumber: number;

  mounted (){
    const _ = this;
    _.getSurveys();
    _.getSection();
    _.getSkill();
    _.getById();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getSurveys(){
    const _ = this;
    _.isLoading = true;
    _.questionService.getSurveys().then((data: any) => {
      _.surveyList = data['data'].surveys;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      _.isLoading = false;
    })
  }

  getSection(){
    const _ = this;
    _.isLoading = true;
    _.questionService.getSection().then((data: any) => {
      _.sectionList = data['data'].sections;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  getSkill(){
    const _ = this;
    _.isLoading = true;
    _.questionService.getSkill().then((data: any) => {
      _.skillList = data['data'].skills;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  edit(){
    const _ = this;
    let question = {
      question: _.question,
      questionNumber: _.questionNumber
    };
    _.isLoading = true;
    let idQuestion: any = location.href.split("/");
    idQuestion = idQuestion[5];
    _.questionService.edit(question, idQuestion).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/questions');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let idQuestion: any = location.href.split("/");
    idQuestion = idQuestion[5];
    _.isLoading = true;
    _.questionService.getById(idQuestion).then((data: any) => {
      _.optionsList = data["data"].question.options;
      _.question = data["data"].question.question;
      _.questionNumber = data["data"].question.questionNumber;
      _.section = data["data"].question.sectionId;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(){
    const _ = this;
    _.genericErr = [];
    // if(question == ''){
    //   _.genericErr.push("Por favor escribe una pregunta");
    //   console.log(_.genericErr, 'erro')
    // }
    if(_.survey == ''){
      _.genericErr.push("Por favor selecciona una encuesta");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
